import _implicitStylesheets from "./autoConfigurator.css";

import _implicitScopedStylesheets from "./autoConfigurator.scoped.css?scoped=true";

import _lightningRadioGroup from "lightning/radioGroup";
import _lightningInput from "lightning/input";
import _lightningButton from "lightning/button";
import _lightningSpinner from "lightning/spinner";
import {registerTemplate, sanitizeAttribute} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {h: api_element, t: api_text, b: api_bind, c: api_custom_element, d: api_dynamic_text} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", {
    classMap: {
      "slds-page-header-margin": true
    },
    key: 0
  }, [api_element("div", {
    classMap: {
      "slds-page-header": true
    },
    key: 1
  }, [api_element("div", {
    classMap: {
      "slds-page-header__row": true
    },
    key: 2
  }, [api_element("div", {
    classMap: {
      "slds-page-header__col-title": true
    },
    key: 3
  }, [api_element("div", {
    classMap: {
      "slds-media": true
    },
    key: 4
  }, [api_element("div", {
    classMap: {
      "slds-media__figure": true
    },
    key: 5
  }, [api_element("img", {
    classMap: {
      "header-icon": true
    },
    attrs: {
      "alt": "smax-icon",
      "src": "/resources/smax-x.png",
      "title": "smax logo"
    },
    key: 6
  }, [])]), api_element("div", {
    classMap: {
      "slds-media__body": true
    },
    key: 7
  }, [api_element("div", {
    classMap: {
      "slds-page-header__name": true
    },
    key: 8
  }, [api_element("div", {
    classMap: {
      "slds-page-header__name-title": true
    },
    key: 9
  }, [api_element("p", {
    classMap: {
      "slds-page-header__name-meta": true
    },
    key: 10
  }, [api_text("Asset 360 Tooling")]), api_element("h1", {
    key: 11
  }, [api_element("span", {
    classMap: {
      "slds-page-header__title": true,
      "slds-truncate": true
    },
    attrs: {
      "title": "Configuration Migration"
    },
    key: 12
  }, [api_text("Configurator")])])])])])])])])])]), api_element("div", {
    classMap: {
      "configurator_align": true,
      "configurator-temp_align": true
    },
    key: 13
  }, [!$cmp.isDataLoaded ? api_text("Deploy To:") : null, !$cmp.isDataLoaded ? api_element("div", {
    classMap: {
      "centered_left": true
    },
    key: 14
  }, [api_element("div", {
    classMap: {
      "conf-radiogrp_align": true
    },
    key: 15
  }, [api_custom_element("lightning-radio-group", _lightningRadioGroup, {
    props: {
      "name": "confRadioGroup",
      "options": $cmp.options,
      "value": $cmp.value,
      "type": "radio"
    },
    key: 16,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.handleChange))
    }
  }, [])]), api_element("div", {
    classMap: {
      "slds-p-around_medium": true,
      "lgc-bg": true,
      "emailId-div_align": true
    },
    key: 17
  }, [api_custom_element("lightning-input", _lightningInput, {
    attrs: {
      "data-my-id": "emailId"
    },
    props: {
      "type": "email",
      "label": "Enter Email address for notifications:"
    },
    key: 18
  }, [])]), api_custom_element("lightning-button", _lightningButton, {
    classMap: {
      "slds-button": true,
      "slds-button_brand": true
    },
    styleDecls: [["width", "400px", false], ["font-size", "0.9rem", false]],
    props: {
      "variant": "brand",
      "label": "Login into Org",
      "title": "Login into Org"
    },
    key: 19,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.getSalesforceSession))
    }
  }, []), api_element("img", {
    classMap: {
      "conf-initial-background": true
    },
    attrs: {
      "alt": "background-van",
      "src": "/resources/background-van.png"
    },
    key: 20
  }, [])]) : null, !$cmp.isDataLoaded ? $cmp.isOrgDataLoaded ? api_custom_element("lightning-spinner", _lightningSpinner, {
    props: {
      "variant": "brand",
      "alternativeText": "seed data loading"
    },
    key: 21
  }, []) : null : null]), api_element("div", {
    styleDecls: [["height", "0rem", false], ["display", "none", false]],
    attrs: {
      "data-my-id": "toastMessageDiv"
    },
    key: 22
  }, [api_element("div", {
    classMap: {
      "slds-notify_container": true,
      "slds-is-relative": true,
      "toast-div_align": true
    },
    key: 23
  }, [api_element("div", {
    classMap: {
      "slds-notify": true,
      "slds-notify_toast": true,
      "slds-theme_success": true
    },
    attrs: {
      "role": "status"
    },
    key: 24
  }, [api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 25
  }, [api_text("success")]), api_element("span", {
    classMap: {
      "slds-icon_container": true,
      "slds-icon-utility-success": true,
      "slds-m-right_small": true,
      "slds-no-flex": true,
      "slds-align-top": true
    },
    attrs: {
      "title": "Deployment status"
    },
    key: 26
  }, [api_element("svg", {
    classMap: {
      "slds-icon": true,
      "slds-icon_small": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 27,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#success")
    },
    key: 28,
    svg: true
  }, [])])]), api_element("div", {
    classMap: {
      "slds-notify__content": true
    },
    key: 29
  }, [api_element("h2", {
    classMap: {
      "slds-text-heading_small": true
    },
    key: 30
  }, [api_text(api_dynamic_text($cmp.statusMessage))])]), api_element("div", {
    classMap: {
      "slds-notify__close": true
    },
    key: 31
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-button_icon-inverse": true
    },
    attrs: {
      "title": "Close"
    },
    key: 32,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.closeToastMessage))
    }
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-button__icon_large": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 33,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#close")
    },
    key: 34,
    svg: true
  }, [])]), api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 35
  }, [api_text("Close")])])])])])]), api_element("div", {
    styleDecls: [["height", "0rem", false], ["display", "none", false]],
    attrs: {
      "data-my-id": "toastErrorMessageDiv"
    },
    key: 36
  }, [api_element("div", {
    classMap: {
      "slds-notify_container": true,
      "slds-is-relative": true,
      "toast-div_align": true
    },
    key: 37
  }, [api_element("div", {
    classMap: {
      "slds-notify": true,
      "slds-notify_toast": true,
      "slds-theme_error": true
    },
    attrs: {
      "role": "status"
    },
    key: 38
  }, [api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 39
  }, [api_text("error")]), api_element("span", {
    classMap: {
      "slds-icon_container": true,
      "slds-icon-utility-error": true,
      "slds-m-right_small": true,
      "slds-no-flex": true,
      "slds-align-top": true
    },
    key: 40
  }, [api_element("svg", {
    classMap: {
      "slds-icon": true,
      "slds-icon_small": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 41,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#error")
    },
    key: 42,
    svg: true
  }, [])])]), api_element("div", {
    classMap: {
      "slds-notify__content": true
    },
    key: 43
  }, [api_element("h2", {
    classMap: {
      "slds-text-heading_small": true
    },
    key: 44
  }, [api_text(api_dynamic_text($cmp.statusMessage))])]), api_element("div", {
    classMap: {
      "slds-notify__close": true
    },
    key: 45
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-button_icon-inverse": true
    },
    attrs: {
      "title": "Close"
    },
    key: 46,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.closeToastErrorMessage))
    }
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-button__icon_large": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 47,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#close")
    },
    key: 48,
    svg: true
  }, [])]), api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 49
  }, [api_text("Close")])])])])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-autoConfigurator_autoConfigurator"
